import {useSearchParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import GarrisonInfoService from "../../../services/reports/garrison-info-service.js";
import {useRef, useState} from "react";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";

export default function GarrisonInfo() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const printComponentRef = useRef(null);
    const title = "Informações da guarnição";

    const { data: reportGarrison, isLoading: isLoadingReport } = useQuery({
        queryKey: ['garrison-info', id],
        queryFn: () => GarrisonInfoService.getGarrison(id),
        enabled: !!id,
    });

    const hasData = !!(reportGarrison?.garrison && Object.keys(reportGarrison?.garrison).length > 0);

    return (
        <>
            <Template isLoading={isLoadingReport || isPrinting}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printable={true}
                        printComponentRef={printComponentRef}
                        reportData={reportGarrison}
                        data={hasData}
                        headerChange={true}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            <NoDataContent reportData={reportGarrison} data={hasData} />
                            <Content
                                id={id}
                                reportData={reportGarrison}
                                data={hasData}
                                entity={headerSelected}
                                title={title}
                                printComponentRef={printComponentRef}
                                setIsPrinting={setIsPrinting}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>
        </>
    )
}